import Tenant from "./Tenant";

const tenant =
{
    edit: Tenant,
};

export default tenant;
